import {
  IFulfillmentAddress,
  IShipment
} from '@broadleaf/admin-components/dist/types/oms';
import { ICommonMonetaryAmount } from '@broadleaf/admin-components/dist/types/common';

export type RevMedShipment = IShipment & {
  carrierCode: string;
  shipmentOptions: ShipmentOptions;
  trackingSummary: TrackingSummary;
  shipmentType: string;
  shipmentStatus: string;
  externalId: string;
  labelCost: ICommonMonetaryAmount;
  insuranceCost: ICommonMonetaryAmount;
  insuranceProvider: string;
  labelPngUrl: string;
  labelPdfUrl: string;
  labelZplUrl: string;
  customsFormPdfUrl: string;
};

export type TrackingSummary = {
  statusCode: string;
  statusDescription: string;
  carrierStatusCode: string;
  carrierDetailCode: string;
  carrierStatusDescription: string;
  exceptionDescription: string;
  estimatedDeliveryDate: string;
  actualDeliveryDate: string;
  lastUpdated: string;
};

export type ShipmentOptions = {
  serviceCode: string;
  carrierCode: string;
  carrierId: string;
  shippingAccountType: string;
  shippingAccountNumber: string;
  shippingAccountPostalCode: string;
  hasDryIce: boolean;
  dryIceWeight: Weight;
  saturdayDelivery: boolean;
  includeShippingInsurance: boolean;
  blindShipment: boolean;
  confirmation: string;
  shipFromAddress: IFulfillmentAddress;
  shipToAddress: IFulfillmentAddress;
  packages: Array<PackageOptions>;
  shippingSettings: ShippingSettings;
};

export type ShippingSettings = {
  showShippingInstructions: boolean;
  labelPreference: ShippingLabelPreference;
};

export enum ShippingLabelPreference {
  COMBINED_LETTER_PDF = "COMBINED_LETTER_PDF",
  SEPARATE_LETTER_PDF = "SEPARATE_LETTER_PDF",
  SEPARATE_4X6_PDF = "SEPARATE_4X6_PDF",
  SEPARATE_LETTER_ZPL = "SEPARATE_LETTER_ZPL",
  SEPARATE_4X6_ZPL = "SEPARATE_4X6_ZPL"
}

export type PackageOptions = {
  weight: Weight;
  insuredValue: ICommonMonetaryAmount;
};

export type Weight = {
  value: number;
  unit: string;
};

export type ShippingRate = {
  name: string;
  description: string;
  useFlatRates: boolean;
  taxCode: string;
  taxable: boolean;
  estimatedDeliveryDate: string;
  fulfillmentPriceCalculated: ICommonMonetaryAmount;
  deliveryDays: number;
  serviceCode: string;
  rateId: string;
  shipmentId: string;
  carrierId: string;
  errorMessages: Array<string>;
  insuranceCost: ICommonMonetaryAmount;
};
